export default "__VITE_PUBLIC_ASSET__88d44855__"